import i18next from "../../../../i18n";

i18next.addResourceBundle("en", "ThemeDropdown", {
    placeholder: "Themes",
    placeholder_active: "Themes ({{count}})",
    setter_text: "{{count}} tags selected",
});

i18next.addResourceBundle("fr", "ThemeDropdown", {
    placeholder: "Themes",
    placeholder_active: "Themes ({{count}})",
    setter_text: "{{count}} tags sélectionnés",
});
